import React from 'react'
import theme from '../config/theme'

interface NavbarProps {
  className?: string
}

const Navbar: React.FC<NavbarProps> = ({ className = '' }) => {
  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 w-full h-16 flex items-center justify-between px-6 ${className}`}
      style={{ backgroundColor: theme.brandColor.red }}
    >
      <div className="flex items-center space-x-4">
        <div 
          className="px-3 py-1 rounded text-white font-bold text-sm"
          style={{ color: theme.brandColor.red, backgroundColor: theme.color.light100 }}
        >
          basm
        </div>
        <span className="text-white font-medium">BGM</span>
      </div>
    </header>
  )
}

export default Navbar
